import * as React from 'react';
import { INearbyResort } from '@/api/region/types';
import { Routes } from '@/routes';
import { NearbyResorts as BaseNearbyResorts } from '@/components/common/NearbyResorts';
import { useOTSTranslation } from '@/i18n/useOTSTranslation';

// Thin api-aware wrapper around common/NearbyResorts. Accepts the
// production INearbyResort[] shape and:
//   - maps each item onto the NearbyResort props
//   - infers the "{region} Resorts" link from the first item's
//     region (when the region has both a slug and a display title)
//
// The shared peer (`@/components/common/NearbyResorts`) is the generic
// presentation primitive. This adapter is the production-data binding
// for the three resort surfaces — drops 60+ lines of legacy
// SwiperComponent chrome that the v3 carousel now owns.

type Props = {
  nearbyResorts: INearbyResort[];
  isSummerMode?: boolean;
};

export const NearbyResorts = ({ nearbyResorts, isSummerMode }: Props) => {
  const { t } = useOTSTranslation('common');
  if (!nearbyResorts?.length) return null;

  const linkRegion = nearbyResorts[0]?.region;
  const link = linkRegion?.slug && linkRegion?.title ? {
    href: Routes.regionTripPlanningOverview(linkRegion),
    label: t('common.viewAllNearbyResorts'),
  } : undefined;

  const resorts = nearbyResorts.map((r) => ({
    name: r.title,
    region: r.region.title,
    img: r.image,
    href: Routes.resortTripPlanningOverview({ ...r, region: r.region.slug }),
  }));

  return (
    <BaseNearbyResorts
      resorts={resorts}
      link={link}
      isSummerMode={isSummerMode}
    />
  );
};
